<template>
  <v-dialog v-model="dialogComputed" max-width="400">
    <v-card>
      <v-card-title class="pt-4">Dike profile creation finished</v-card-title>
      <v-card-text class="pl-4 pt-0">
        {{ message }}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            v-if="$route.name !=='dikeIndex-trajectory'"
            @click="navigateToProject(); setDialog(false)"
            color="primary"
            variant="text"
        >
          Go to dike dike trajectory
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>
<script>

import {mapActions, mapState} from "vuex";

export default {
  name: 'UploadDoneDialog',
  data: () => ({}),
  computed: {
    ...mapState('webSocket', {
      dialog: state => state.dialog,
      message: state => state.message,
    }),
    routeId() {
      return this.$route.params.id
    },
    dialogComputed: {
      get() {
        return this.dialog
      }, set(value) {
        this.setDialog(value)
      }
    }
  },
  methods: {
    ...mapActions("webSocket", {
      setWebSocket: "setWebSocket",
      setDialog: "setDialog"
    }),
    async navigateToProject() {
      await this.$router.push({name: 'dikeIndex-trajectory', params: {'id': this.$route.params.id}})
    },

  },
  mounted() {
    this.setWebSocket(this.$route.params.id);
  }
}
</script>